import { useContext } from 'react';

import { LanguageContext } from 'App/Providers/games';

import './styles.scss';
import lightningLogo from '../../assets/lightning-hero_logo.svg';
import LanguageSelector from '../../components/LanguageSelector';
import polyglot from '../../localization';

const Header = ({ phase, backgroundSelector }) => {
    const { locale, changeLanguage } = useContext(LanguageContext);

    return (
        <header>
            <div className='logo-container wrapper container'>
                <div className='logo'>
                    <img
                        src={lightningLogo}
                        width={155}
                        height={123}
                        alt={polyglot.t(`${locale}.hero.alt.logo`)}
                    />
                </div>
                <LanguageSelector
                    phase={phase}
                    locale={locale}
                    changeLanguage={changeLanguage}
                    backgroundSelector={backgroundSelector}
                />
            </div>
        </header>
    );
};

export default Header;
